var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserAlt = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 96 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M80.7 95.1 56.8 71.2c-2.4-2.4-5.6-3.7-9-3.7-3.4 0-6.6 1.3-9 3.7L14.9 95.1 10 90.2l23.9-23.9c7.7-7.7 20.1-7.7 27.8 0l23.9 23.9-4.9 4.9zm-7.3-69.5C73.4 11.5 61.9 0 47.8 0 33.7 0 22.2 11.5 22.2 25.6c0 14.1 11.5 25.6 25.6 25.6 14.1 0 25.6-11.5 25.6-25.6zm-7 0c0 10.2-8.3 18.6-18.6 18.6-10.2 0-18.6-8.3-18.6-18.6S37.6 7 47.8 7C58 7 66.4 15.3 66.4 25.6z",
  fill: "currentColor"
})));
export default SvgUserAlt;